module.exports = __webpack_public_path__ + "img/pointy hat.5d1fc741.png";